export default __webpack_public_path__ + "static/media/huge.802a0567.gif";